import { render, staticRenderFns } from "./ManageDocs.vue?vue&type=template&id=438dfbb6&scoped=true&"
import script from "./ManageDocs.vue?vue&type=script&lang=js&"
export * from "./ManageDocs.vue?vue&type=script&lang=js&"
import style0 from "./ManageDocs.vue?vue&type=style&index=0&id=438dfbb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438dfbb6",
  null
  
)

export default component.exports